module.exports = __webpack_public_path__ + "img/安益集團_Logo_3.aa28bcbb.svg";